import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ServicesSection } from '../components/ServicesSection';
import { SolutionsSection } from '../components/SolutionsSection';
import { PricingSection } from '../components/PricingSection';
export function HomePage() {
  return <>
      <HeroSection data-id="element-798" />
      <ServicesSection data-id="element-799" />
      <SolutionsSection data-id="element-800" />
      <PricingSection data-id="element-801" />
    </>;
}